<template>
    <div :class="{ flex: !toggler.isOpen() }">
        <div>生日</div>
        <div>
            <div class="editable" v-show="!toggler.isOpen()">
                <span class="no-data color:#333333" v-if="props.value">{{ props.value }}</span>
                <span class="no-data color:#333333" v-else>尚未確認生日</span>
                <button @click="open" type="button">
                    <img alt="" class="w:20 h:20" src="image/icon_pen.svg" />
                </button>
            </div>
            <div class="{mt:8}@<md" v-show="toggler.isOpen()">
                <div class="row {mx:-6}@<sm {px:6}>.col-4@<sm">
                    <div class="col-4">
                        <decorator-input class="form-control" :decorator="(v) => `${v} 年`" :disabled="errors.birthday" inputmode="numeric" placeholder="年" ref="input" type="text" v-model.trim="form.year"></decorator-input>
                    </div>
                    <div class="col-4">
                        <decorator-input class="form-control" :decorator="(v) => `${v} 月`" :disabled="errors.birthday" inputmode="numeric" placeholder="月" type="text" v-model.trim="form.month"></decorator-input>
                    </div>
                    <div class="col-4">
                        <decorator-input class="form-control" :decorator="(v) => `${v} 日`" :disabled="errors.birthday" inputmode="numeric" placeholder="日" type="text" v-model.trim="form.date"></decorator-input>
                    </div>
                </div>
                <div class="mt:8">
                    <div class="info-msg" v-if="errors.birthday">
                        您的生日已修改過一次，無法再次變更，請 <a class="font-weight:700" href="https://lin.ee/LpdcFiE" target="_blank">聯絡我們</a>
                    </div>
                    <div class="info-msg" v-else>
                        生日僅可自行變更一次，請輸入西元年
                    </div>
                </div>
                <div class="t:right mt:8 {ml:8}>button+button">
                    <button class="btn btn-sm btn-link" @click="close" type="button">取消</button>
                    <button class="btn btn-sm bg:#EEF3FB! color:#4776B4!" @click="save()" :disabled="!available_birthday" type="button">儲存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    let submited = false;

    const available_birthday = computed(() => birthday.value && birthday.value !== props.value);

    const birthday = computed(() => {
        if (form.value.year && form.value.month && form.value.date) {
            return [form.value.year, form.value.month < 10 ? `0${form.value.month}` : form.value.month, form.value.date < 10 ? `0${form.value.date}` : form.value.date].join("-");
        }
    });

    const errors = ref({});

    const form = ref({});

    const input = ref();

    const props = defineProps({
        value: { required: true, type: String }
    });

    const toggler = ToggleStore().toggler("profile_birthday");

    const close = () => {
        if (available_birthday.value) {
            emit("cancel", () => toggler.close());
        } else {
            toggler.close();
        }
    };

    const emit = defineEmits(["cancel", "error", "login", "update"]);

    const open = () => {
        if (submited) {
            return;
        }
        submited = true;
        api("api/member/history", { type: "birthday" }, { prevent: true }).done((res) => {
            form.value.year = parseInt(props.value.split("-")[0]).toString();
            form.value.month = parseInt(props.value.split("-")[1]).toString();
            form.value.date = parseInt(props.value.split("-")[2]).toString();
            errors.value.birthday = res.data?.length;
            toggler.open();
            setTimeout(() => input.value.focus());
        }).always(() => {
            submited = false;
        });
    };

    const save = (password) => {
        if (submited) {
            return;
        }
        submited = true;
        api("api/member/save-birthday", { birthday: birthday.value, password }, { prevent: true }).done((res) => {
            if (res.success) {
                emit("update", birthday.value);
                toggler.close();
            } else if (res.error === "error.permission-denied") {
                emit("login", save);
            } else {
                emit("error", res.message);
            }
        }).always(() => {
            submited = false;
        });
    };
</script>
